var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.languages),function(lang){return [_c('div',{key:lang,on:{"click":function($event){return _vm.setLocale(lang)}}},[_vm._t("default",null,{"label":_vm.$t('locale.' + lang),"active":_vm.locale === lang})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }